export default "__VITE_ASSET__DjBSrEci__"